import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
// Pages
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Pricing } from './pages/Pricing';
import { Astrology } from './pages/Astrology';
import { Testimonials } from './pages/Testimonials';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Contact } from './pages/Contact';
import { Booking } from './pages/Booking';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';
// Fallback for simple text pages
const TextPage = ({
  title
}: {
  title: string;
}) => <div className="container mx-auto px-6 py-32 max-w-3xl text-center" data-id="element-0">
    <h1 className="text-4xl md:text-5xl font-serif text-white mb-6" data-id="element-1">{title}</h1>
    <p className="text-beige-muted text-lg" data-id="element-2">
      This page is being updated with sacred knowledge. Please check back soon.
    </p>
  </div>;
export function App() {
  return <Router data-id="element-3">
      <Layout data-id="element-4">
        <Routes data-id="element-5">
          <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
          <Route path="/about" element={<About data-id="element-9" />} data-id="element-8" />
          <Route path="/services" element={<Services data-id="element-11" />} data-id="element-10" />
          <Route path="/services/:slug" element={<ServiceDetail data-id="element-13" />} data-id="element-12" />
          <Route path="/pricing" element={<Pricing data-id="element-15" />} data-id="element-14" />
          <Route path="/astrology" element={<Astrology data-id="element-17" />} data-id="element-16" />
          <Route path="/testimonials" element={<Testimonials data-id="element-19" />} data-id="element-18" />
          <Route path="/blog" element={<Blog data-id="element-21" />} data-id="element-20" />
          <Route path="/blog/:slug" element={<BlogPost data-id="element-23" />} data-id="element-22" />
          <Route path="/contact" element={<Contact data-id="element-25" />} data-id="element-24" />
          <Route path="/booking" element={<Booking data-id="element-27" />} data-id="element-26" />
          <Route path="/login" element={<Login data-id="element-29" />} data-id="element-28" />

          {/* Utility Pages */}
          <Route path="/privacy" element={<TextPage title="Privacy Policy" data-id="element-31" />} data-id="element-30" />
          <Route path="/terms" element={<TextPage title="Terms of Service" data-id="element-33" />} data-id="element-32" />

          {/* 404 Fallback */}
          <Route path="*" element={<NotFound data-id="element-35" />} data-id="element-34" />
        </Routes>
      </Layout>
    </Router>;
}